import TeamLevel from '@maxpreps/shared/constants/teamLevel';
import useTeamContext from '@maxpreps/shared/contexts/TeamContext';
import PickerButton from '@maxpreps/shared/corecomponents/PickerModal/PickerButton';
import { formatTeamLevel } from '@maxpreps/shared/functions/utils/sportSeasonUtils';
import useToggle from '@maxpreps/shared/hooks/useToggle';
import { useCallback } from 'react';
import { getProgramCanonicalUrl } from './../../../utils/navigation';
import SeasonPicker from './SeasonPicker';
import SeasonPickerSSR from './SeasonPickerSSR';

const SeasonPickerButton = () => {
  const [isOpen, , onOpen, onClose] = useToggle(false);
  const teamContext = useTeamContext();

  const { sport, level, year } = teamContext.data;
  const { teamSeasonPickerData } = teamContext;
  const levelAbbr = formatTeamLevel(level as TeamLevel);

  const _onOpen = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();

      onOpen();
    },
    [onOpen]
  );

  return (
    <>
      <PickerButton
        onOpen={_onOpen}
        sport={sport}
        text={`${year} ${levelAbbr}. ${sport}`}
        href={getProgramCanonicalUrl(teamSeasonPickerData, level)}
      />
      <SeasonPickerSSR />
      {isOpen && <SeasonPicker onClose={onClose} />}
    </>
  );
};

export default SeasonPickerButton;
